import {callBackendApi} from "../../../components/service/axios";

export const fetchPolicyList = async (page, size, userQuery, sorter) => {
    return await callBackendApi("get", "/bff/policies", null, {
        page: page,
        size: size,
        sortField: sorter.sortField,
        sortDirection: sorter.sortDirection,
        name: userQuery.name,
        id: userQuery.id,
        group: userQuery.group,
        scope: userQuery.scope,
        actions: userQuery.actions,
        systemResource: userQuery.systemResource,
    });
};
